module.exports = __webpack_public_path__ + "static/media/xcxewm.682237ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/xcxewm.jpg
// module id = 1049
// module chunks = 2